import { useCallback, ChangeEvent } from 'react'
import { useDispatch } from 'react-redux'
import { Optional } from 'packages/types'
import { AsyncAutosuggest, createSuggestionsApiFetcher } from 'builder/components/AsyncAutosuggest'
import EditorField from 'builder/components/EditorField'
import { TextField } from 'builder/components/TextField'
import { useI18n } from 'builder/hooks/useI18n'
import { actions as editorActions } from 'builder/modules/resumeEditor'

type Props = {
  countryName: Optional<string>
  locale: string
}

export const Country = (props: Props) => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const { countryName, locale } = props

  const handleSimpleFieldUpdate = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target
      dispatch(editorActions.updateSimpleField({ name: 'countryName', value, debounce: true }))
    },
    [dispatch],
  )

  return (
    <>
      {/* Country */}
      <EditorField>
        <AsyncAutosuggest
          highlightedQuery
          name="countryName"
          fetchItems={createSuggestionsApiFetcher('country', { locale })}
          value={countryName || ''}
          onChange={handleSimpleFieldUpdate}
        >
          {({ key, ...inputProps }) => (
            <TextField {...inputProps} key={key} label={i18n.t('builder.resume_editor.country')} />
          )}
        </AsyncAutosuggest>
      </EditorField>
    </>
  )
}
